import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiService } from 'services';
import CONSTANTS from 'utils/constants';

export const fetchCities = createAsyncThunk(
  'cities/fetchCities',
  async ({siteTypes = [CONSTANTS.SITE_TYPE.AcademicInstitution], includeInactive = false} = {}) => {
    try {
      const queryParams = buildCitiesQuery(siteTypes, includeInactive);
      const response = await ApiService.get(`City/GetCitiesSites${queryParams}`);
      return response.data.content.cities;
    } catch (error) {
      throw new Error('Error fetching cities');
    }
  }
);

const buildCitiesQuery = (siteTypes, includeInactive) => {
  const searchParams = new URLSearchParams();
  
  if (Array.isArray(siteTypes) && siteTypes.length > 0) {
    siteTypes
      .filter(siteType => siteType != null && siteType !== '')
      .forEach(siteType => searchParams.append('siteTypes', siteType));
  }

  searchParams.set('includeInactive', includeInactive === true ? 'true' : 'false');
  
  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};
